<template>
    <!-- 举报投诉 -->
    <div style="overflow-y: scroll;">
        <NavBar :title="guid?'举报明细':'举报投诉'" :leftText="guid?true:false" :right-text="guid?undefined:'历史记录'" @onClickRight="onClickRight"/>
        <van-form label-width="30vmin" :readonly="readonly" ref="form" validate-first @submit="onSubmit" @failed="failed">
            <van-field maxlength="15" autocomplete="off" v-model="form.byComplaintPersonId" name="被举报人工号" label="被举报人工号" :placeholder="guid?'':'必填'" :rules="[{required:true}]" @input="noChange"/>
            <van-field maxlength="10" autocomplete="off" v-model="form.byComplaintPersonName" name="被举报人姓名" label="被举报人姓名" :placeholder="guid?'':'必填'" :rules="[{required:true}]"/>
            <van-field maxlength="60" autocomplete="off" v-model="form.byComplaintDept" name="被举报人单位" label="被举报人单位" :placeholder="guid?'':'必填'" :rules="[{required:true}]" autosize type="textarea"/>
            <!-- <van-field maxlength="20" autocomplete="off" v-model="form.byComplaintDept2" name="被举报人二级单位" label="被举报人二级单位" :placeholder="guid?'':'必填'" :rules="[{required:true}]"/> -->
            <van-field autocomplete="off" v-model="form.complaintContent" name="举报内容" label="举报内容" :placeholder="guid?'':'必填'" :rules="[{required:true}]" rows="5" autosize type="textarea" maxlength="5000" show-word-limit/>
            <!-- <van-field label="上传文件" :rules="[{required:false}]">
                <template #input>
                    <van-uploader :disabled="readonly" multiple :max-count="20" :after-read="fileRead"/>
                </template>
            </van-field> -->
            <FieldUpload :fileIds="imgList" label="上传图片" type="IMG" :disabled="readonly" @fileChange="imgList=$event"/>
            <!-- <van-field label="上传图片" :rules="[{required:false}]">
                <template #input>
                    <van-uploader :disabled="readonly" multiple :max-count="20" :after-read="imgRead"/>
                </template>
            </van-field> -->
            <FieldUpload :fileIds="fileList" :disabled="readonly" @fileChange="fileList=$event"/>
            <van-field label="您的信息" :rules="[{required:false}]">
                <template #input>
                    <van-radio-group v-model="form.info" direction="horizontal" :disabled="readonly" @change="infoChange">
                        <van-radio name="填写">填写</van-radio>
                        <van-radio name="不填写">不填写</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <template v-if="form.info=='填写'">
                <van-field maxlength="10" autocomplete="off" v-model="form.name" name="姓名" label="姓名" :placeholder="guid?'':'鼓励填写，严格保密'" :rules="[{required:form.info='填写'}]"/>
                <van-field maxlength="20" autocomplete="off" v-model="form.dept" name="单位" label="单位" :rules="[{required:form.info='填写'}]"/>
                <van-field maxlength="20" autocomplete="off" v-model="form.phone" name="手机" label="手机" :placeholder="guid?'':'手机/邮箱 必填其一'" :rules="[{required:false}]" @input="validate" :error="msg" @blur="validate"/>
                <van-field maxlength="30" autocomplete="off" v-model="form.email" name="邮箱" label="邮箱" :placeholder="guid?'':'手机/邮箱 必填其一'" :rules="[{required:false}]" @input="validate" :error="msg" @blur="validate"/>
            </template>
            <div v-else style="padding:5vmin;">
                实名举报线索将优先进行调查，我们对举报人信息严格保密。不提供联系方式，我们将无法与您取得联系，了解更多信息，同时您也无法了解调查的进展与结果。
            </div>
            <van-cell v-if="!readonly" center>
                <van-button type="info" round loading-text="提交中。。。" :loading="loading">提交</van-button>
            </van-cell>
        </van-form>
    </div>
</template>
<script>
export default {
    data(){
        return{
            guid:'',
            readonly:false,
            loading:false,
            form:{
                info:'填写'
            },
            msg:false,
            fileList:[],
            imgList:[]
        }
    },
    mounted(){
        document.title='举报投诉'
        this.guid = this.$route.query.guid
        if(this.guid){
            this.readonly = true
            this.$http.get('/api/ts/v0.1/complaint/'+this.guid)
            .then(res=>{
                this.form = res.data
                if(this.form.imgs){
                    this.imgList = this.form.imgs.split(',')
                }else{
                    this.imgList = []
                }
                if(this.form.files){
                    this.fileList = this.form.files.split(',')
                }else{
                    this.fileList = []
                }
            })
        }
    },
    methods:{
        validate(){
            this.$set(this,'msg',(this.form.phone||this.form.email)?false:true)
            return this.msg;
        },
        onSubmit(){
            if(this.form.info=='填写'&&this.validate()){
                return
            }
            if(this.fileList && this.fileList.length>0){
                this.form.files = this.fileList.join(',')
            }else{
                this.form.files = undefined
            }
            if(this.imgList && this.imgList.length>0){
                this.form.imgs = this.imgList.join(',')
            }else{
                this.form.imgs = undefined
            }
            this.Dialog.confirm({
                title:'警告',
                message:'请确认是否提交数据，提交后数据将不能修改。'
            }).then(()=>{
                this.loading = true
                this.$http.post('/api/ts/v0.1/complaint/save',this.form)
                .then(res=>{
                    if (res.data >= 1) {
                        this.form = {info:'填写'}
                        this.fileList = []
                        this.imgList = []
                        // this.$message.success('操作成功')
                        this.Dialog.alert({
                            title:'提醒',
                            message:'操作成功'
                        })
                        // this.form = {}
                    } else if(res.data) {
                        // this.$message.error('操作失败')
                        this.Dialog.alert({
                            title:'警告',
                            message:'操作失败'
                        })
                    }else{
                        // this.$message.error('您已经提交过了') 
                        this.Dialog.alert({
                            title:'警告',
                            message:'您已经提交过了'
                        })
                    }
                    this.loading = false
                })
                .catch((err)=>{
                    this.loading = false
                    // this.$message.error('操作失败')
                    this.Dialog.alert({
                        title:'警告',
                        message:'操作失败'
                    })
                })
            }).catch(()=>{

            })
            
        },
        failed(err){
            this.Dialog.alert({
                title:'警告',
                message:'请填写'+err.errors[0].name
            })
            // this.$message.error()
        },
        infoChange(){
            if(this.form.info == '不填写'){
                this.form.name = ''
                this.form.dept = ''
                this.form.phone = ''
                this.form.email = ''
            }
        },
        onClickRight(){
            this.$router.push({
                name: "table"
            });
        },
        infoChange(){
            this.$set(this.form,'name',undefined)
            this.$set(this.form,'dept',undefined)
            this.$set(this.form,'phone',undefined)
            this.$set(this.form,'email',undefined)
            this.$set(this,'msg',false)
            this.$refs.form.resetValidation()
        },
        noChange(){
            if(this.form.byComplaintPersonId){
                this.$set(this.form,'personPhone',JSON.parse(localStorage.getItem('userInfo')).phone)
                this.$http.get('/api/ts/v0.1/common/getUserInfoByNo',{params:{userId:this.form.byComplaintPersonId}})
                .then(res=>{
                    if(res.data){
                        this.$set(this.form,'byComplaintPersonName',res.data.name)
                        this.$set(this.form,'byComplaintDept',res.data.deptAllPath?res.data.deptAllPath.replace('SANY/',''):'')
                        
                    }else{
                        this.$set(this.form,'byComplaintPersonName','')
                        this.$set(this.form,'byComplaintDept','')
                    }
                })
                .catch((err)=>{
                    this.$set(this.form,'byComplaintPersonName','')
                    this.$set(this.form,'byComplaintDept','')
                })
            }else{
                this.$set(this.form,'byComplaintPersonName','')
                this.$set(this.form,'byComplaintDept','')
            }
            
        }
    },
    watch:{
        "form.info":function(){
            this.infoChange()
        }
    }
}
</script>
<style scoped>
    table,tr,td{
        border:1px solid #D8D8D8;
        padding:5px;
    }
    tr{
        text-align: center;
        height:55px;
    }
</style>